define("analytics-resources/components/analytics-resource/word-cloud", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "analytics-resources/types/chart-types", "analytics-resources/utils/charts/chart-utils", "shared/utils/uuid", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _chartTypes, _chartUtils, _uuid, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"analytics-resources/types/chart-types",0,"analytics-resources/utils/charts/chart-utils",0,"shared/utils/uuid",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div {{did-insert this.chart}} {{did-update this.chart @chartData @chartState}} ...attributes>
    <div class="cCH--chart">
      <div id={{this.chartId}}></div>
  
      {{#if this.showEmptyChart}}
        <div class="cCH--chart__overlay"></div>
      {{/if}}
  
      {{#if (eq @chartState "loading")}}
        <div class="cCH--chart__overlay">
          <Shared::Ui::CalculatingState
            @text={{t "social-listening.listener.section.loading"}}
            class="u--text--uppercase"
          />
        </div>
      {{else if (eq @chartState "backfilling")}}
        <div class="cCH--chart__overlay">
          <Shared::Ui::CalculatingState
            @text={{html-safe (t "social-listening.listener.section.backfilling")}}
            class="u--text--uppercase u--text--center"
          />
        </div>
      {{else if (eq @chartState "no-data")}}
        <div class="cCH--chart__overlay">
          <p class="u--m__b__0">
            {{t "analytics-resources.state.no_insights"}}
          </p>
        </div>
      {{else if (eq @chartState "error")}}
        <div class="cCH--chart__overlay">
          {{#if (has-block "errorOverlay")}}
            {{yield to="errorOverlay"}}
          {{else}}
            <p class="u--m__b__0">
              {{t "analytics-resources.state.error"}}
            </p>
          {{/if}}
        </div>
      {{else if (eq @chartState "refresh-profile")}}
        <Listener::Charts::RefreshCredentials />
      {{/if}}
    </div>
  </div>
  */
  {
    "id": "HtPnUlSG",
    "block": "[[[11,0],[17,1],[4,[38,0],[[30,0,[\"chart\"]]],null],[4,[38,1],[[30,0,[\"chart\"]],[30,2],[30,3]],null],[12],[1,\"\\n  \"],[10,0],[14,0,\"cCH--chart\"],[12],[1,\"\\n    \"],[10,0],[15,1,[30,0,[\"chartId\"]]],[12],[13],[1,\"\\n\\n\"],[41,[30,0,[\"showEmptyChart\"]],[[[1,\"      \"],[10,0],[14,0,\"cCH--chart__overlay\"],[12],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[28,[37,3],[[30,3],\"loading\"],null],[[[1,\"      \"],[10,0],[14,0,\"cCH--chart__overlay\"],[12],[1,\"\\n        \"],[8,[39,4],[[24,0,\"u--text--uppercase\"]],[[\"@text\"],[[28,[37,5],[\"social-listening.listener.section.loading\"],null]]],null],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,3],[[30,3],\"backfilling\"],null],[[[1,\"      \"],[10,0],[14,0,\"cCH--chart__overlay\"],[12],[1,\"\\n        \"],[8,[39,4],[[24,0,\"u--text--uppercase u--text--center\"]],[[\"@text\"],[[28,[37,6],[[28,[37,5],[\"social-listening.listener.section.backfilling\"],null]],null]]],null],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,3],[[30,3],\"no-data\"],null],[[[1,\"      \"],[10,0],[14,0,\"cCH--chart__overlay\"],[12],[1,\"\\n        \"],[10,2],[14,0,\"u--m__b__0\"],[12],[1,\"\\n          \"],[1,[28,[35,5],[\"analytics-resources.state.no_insights\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,3],[[30,3],\"error\"],null],[[[1,\"      \"],[10,0],[14,0,\"cCH--chart__overlay\"],[12],[1,\"\\n\"],[41,[48,[30,4]],[[[1,\"          \"],[18,4,null],[1,\"\\n\"]],[]],[[[1,\"          \"],[10,2],[14,0,\"u--m__b__0\"],[12],[1,\"\\n            \"],[1,[28,[35,5],[\"analytics-resources.state.error\"],null]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]]],[1,\"      \"],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,3],[[30,3],\"refresh-profile\"],null],[[[1,\"      \"],[8,[39,9],null,null,null],[1,\"\\n    \"]],[]],null]],[]]]],[]]]],[]]]],[]]],[1,\"  \"],[13],[1,\"\\n\"],[13]],[\"&attrs\",\"@chartData\",\"@chartState\",\"&errorOverlay\"],false,[\"did-insert\",\"did-update\",\"if\",\"eq\",\"shared/ui/calculating-state\",\"t\",\"html-safe\",\"has-block\",\"yield\",\"listener/charts/refresh-credentials\"]]",
    "moduleName": "analytics-resources/components/analytics-resource/word-cloud.hbs",
    "isStrictMode": false
  });
  let WordCloudComponent = _exports.default = (_dec = (0, _service.inject)('highcharts-library'), (_class = class WordCloudComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "highchartsLibrary", _descriptor, this);
      _defineProperty(this, "chartId", `growth-chart-word-cloud-${(0, _uuid.default)()}`);
    }
    get showEmptyChart() {
      return (0, _chartUtils.showEmptyChart)(this.args.chartState);
    }
    get chartOptions() {
      return {
        ...this.commonOptions,
        chart: {
          ...this.commonOptions.chart,
          type: 'wordcloud',
          className: this.args.customChartClass || 'detailed-y-chart'
        },
        tooltip: {
          shape: 'square',
          shadow: false,
          useHTML: true,
          padding: 6,
          formatter: this.args.chartOptions.tooltipFormatter
        },
        series: [{
          type: 'wordcloud',
          data: this.args.chartData ?? [],
          name: this.args.name,
          clip: false,
          events: {
            click: this.args.chartOptions.chartClickEvent ?? undefined
          }
        }]
      };
    }
    get emptyChartOptions() {
      return {
        ...this.commonOptions,
        chart: {
          ...this.commonOptions.chart,
          className: 'cCH--chart--disabled'
        },
        tooltip: {
          enabled: false
        },
        series: [{
          type: 'wordcloud',
          data: this.args.chartState === _chartTypes.ChartState.Loading ? [{
            name: 'loading...',
            weight: 10,
            className: 'highcharts-social-listening-series-disabled'
          }, {
            name: 'loading...',
            weight: 9,
            className: 'highcharts-social-listening-series-disabled'
          }, {
            name: 'loading...',
            weight: 8,
            className: 'highcharts-social-listening-series-disabled'
          }, {
            name: 'loading...',
            weight: 7,
            className: 'highcharts-social-listening-series-disabled'
          }, {
            name: 'loading...',
            weight: 6,
            className: 'highcharts-social-listening-series-disabled'
          }, {
            name: 'loading...',
            weight: 5,
            className: 'highcharts-social-listening-series-disabled'
          }, {
            name: 'loading...',
            weight: 4,
            className: 'highcharts-social-listening-series-disabled'
          }, {
            name: 'loading...',
            weight: 3,
            className: 'highcharts-social-listening-series-disabled'
          }] : undefined,
          name: this.args.name,
          className: 'cCH--chart--disable',
          clip: false
        }]
      };
    }
    get commonOptions() {
      return {
        title: undefined,
        chart: {
          styledMode: true,
          height: this.args.chartOptions.height || 170,
          spacing: this.args.chartOptions.spacing ?? [25, 0, 0, 0]
        },
        credits: {
          enabled: false
        },
        legend: {
          enabled: false
        },
        plotOptions: {
          series: {
            animation: false,
            marker: {
              enabled: false
            },
            states: {
              hover: {
                enabled: false
              }
            }
          },
          wordcloud: {
            minFontSize: 7,
            maxFontSize: 16,
            style: {
              fontFamily: 'Arial',
              fontWeight: '300'
            },
            rotation: {
              from: 0,
              to: 0
            }
          }
        }
      };
    }
    chart() {
      const chartOptions = this.showEmptyChart ? this.emptyChartOptions : this.chartOptions;
      this.highchartsLibrary.chart(this.chartId, chartOptions);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "highchartsLibrary", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "chart", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "chart"), _class.prototype)), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, WordCloudComponent);
});